import { DoubleYourOddsColorIcon, EnhancedOddsColorIcon, EpicBoostColorIcon, SuperOddsColorIcon, YourOddsColorIcon, TopAccaIcon, PriceBoostIcon, } from '@ui-kit-ngs/icons';
export const mapConcessionToIcons = {
    YourOdds: {
        icon: YourOddsColorIcon,
        label: '#YourOdds',
    },
    SuperOdds: {
        icon: SuperOddsColorIcon,
        label: 'Super Odds',
    },
    EnhancedOdds: {
        icon: PriceBoostIcon,
        label: 'Price Boost',
    },
    FlashOdds: {
        icon: PriceBoostIcon,
        label: 'Price Boost',
    },
    EpicOdds: {
        icon: EpicBoostColorIcon,
        label: 'Epic Boost',
    },
    DoubleYourOdds: {
        icon: DoubleYourOddsColorIcon,
        label: 'Double #YourOdds',
    },
    TopPriceGuarantee: {
        icon: EnhancedOddsColorIcon,
        label: 'Top Price Guarantee',
    },
    TopAcca: {
        icon: TopAccaIcon,
        label: 'Top Acca',
    },
};
